module.exports = __webpack_public_path__ + "static/media/poney.2766a90d.png";